<div class="w-full h-full flex" *ngIf="collections">
    <!-- Collection list -->
    <div class="w-full md:w-[280px] xl:w-[440px] bg-app-collections-list-background flex flex-col shrink-0 border-r-[1px] border-app-collections-list-border-right"
        *ngIf="collections.length">
        <div class="absolute w-full md:w-[280px] xl:w-[440px] h-[calc(100%-75px)] lg:h-full top-auto left-0 bg-[rgba(238,238,238,0.6)] z-10"
            *ngIf="mode === 'new' || mode === 'edit'">
        </div>

        <!-- New collection and search -->
        <div class="flex flex-col xl:flex-row gap-5 p-5 ">
            <!-- New collection -->
            <button mat-flat-button color="primary" *ngIf="connection.role.value !== 'chatter'"
                (click)="addCollection()" routerLink="/collections/new" i18n>
                Nieuwe collectie
            </button>
            <!-- Search -->
            <mat-form-field class="grow search">
                <input matInput i18n-placeholder placeholder="Zoeken..." [formControl]="searchCollectionsControl">
            </mat-form-field>
        </div>

        <!-- No filter results -->
        <p class="text-xl px-5 text-center text-app-global-text-secondary"
            *ngIf="collections?.length && !filteredCollections?.length" i18n>
            Geen zoekresultaten gevonden
        </p>

        <div class="flex flex-col gap-[10px] overflow-auto px-5 pb-5">
            <!-- New collection -->
            <div class="flex flex-col gap-[10px] z-[16]" *ngIf="mode === 'new' && breakpoint.md.value" appShrinkGrow>
                <!-- New collection  -->
                <div
                    class="bg-app-collections-collection-card-selected-background flex flex-col py-10 px-5 items-center rounded-[20px] border-app-collections-collection-card-selected-border border">
                    <p class="text-lg font-semibold" i18n>Nieuwe collectie</p>
                </div>
            </div>

            <!-- Existing collections -->
            <div class="flex flex-col gap-[10px]" *ngFor="let collection of filteredCollections; trackBy:collectionById"
                class="collection-card"
                [ngClass]="{'selected': collection.id === selectedCollectionControl.value?.id, 'failed': collection?.status === 'failed'}"
                (click)="selectCollection(collection)" routerLink="/collections/{{collection.id}}">
                <div
                    class="card-details bg-white flex flex-col gap-[15px] p-5 items-start rounded-[20px] overflow-hidden w-full">
                    <div class="flex justify-between items-center w-full">
                        <p class="text-lg font-semibold line-clamp-3 text-ellipsis">{{collection.name}}</p>
                        <div class="flex items-center">
                            <!-- Processing -->
                            <mat-icon class="shrink-0 h-6 w-6 text-app-global-text-secondary" svgIcon="file-clock"
                                *ngIf="collection?.status === 'processing'"></mat-icon>
                            <!-- Failed -->
                            <mat-icon class="shrink-0 h-6 w-6 text-app-global-warning" svgIcon="file-warning"
                                *ngIf="collection?.status === 'failed'"></mat-icon>
                            <!-- Private -->
                            <mat-icon class="shrink-0 h-6 w-6 text-app-global-text-secondary" svgIcon="eye-off"
                                *ngIf="collection?.private" i18n-matTooltip matTooltip="Alleen zichtbaar voor mij">
                            </mat-icon>
                        </div>
                    </div>
                    <div class="flex flex-col gap-[5px] w-full">
                        <p *ngIf="collection.Documents.length" class="text-app-global-text-secondary" i18n>
                            Documenten
                        </p>
                        <p *ngIf="!collection.Documents.length" class="text-app-global-text-secondary" i18n>
                            Geen documenten
                        </p>
                        <!-- Files -->
                        <div class="flex flex-col gap-[10px]">
                            <div *ngFor="let document of collection.Documents | slice: 0:3"
                                class="flex items-center gap-[7px]"
                                [ngClass]="{'processing': document.status === 'processing'}">
                                <mat-icon *ngIf="document.status === 'processing'" svgIcon="file-clock"
                                    class="h-5 w-5 shrink-0 text-app-global-text-secondary"></mat-icon>
                                <mat-icon *ngIf="document.status === 'failed'" svgIcon="file-warning"
                                    class="h-5 w-5 shrink-0 text-app-global-warning"></mat-icon>
                                <mat-icon *ngIf="document.status === 'available'" svgIcon="file"
                                    class="h-5 w-5 shrink-0 text-app-global-primary"></mat-icon>
                                <p class="text-base text-app-global-primary overflow-hidden text-ellipsis whitespace-nowrap document-title"
                                    [ngClass]="{'text-app-global-warning': document.status === 'failed'}">
                                    {{document.File.name}}
                                </p>
                            </div>
                        </div>
                        <p class="text-app-global-text-secondary text-base" *ngIf="collection.Documents.length > 5"
                            i18n>
                            En nog {{collection.Documents.length - 3}} meer
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Edit or detail component based on mode -->
    <div class="z-10 absolute top-0 left-0 w-full h-[calc(100%-75px)] md:relative md:w-auto md:h-auto bg-white grow overflow-auto lg:pt-0"
        *ngIf="selectedCollectionControl.value || (mode && mode !== 'detail')" [ngClass]="{'pt-3 ': mode === 'detail'}">

        <!-- Edit and new -->
        <app-collection-edit class="grow" *ngIf="mode === 'new' || mode === 'edit'"
            [firstCollection]="!collections.length"></app-collection-edit>
        <!-- Detail -->
        <app-collection-detail class="grow " *ngIf="mode === 'detail'"
            (collectionUpdated)="getCollections()"></app-collection-detail>
    </div>

    <!-- Select collection message. In normal circumstances a collection will always be selected, but when the user switches from mobile screen size to desktop
     this could happen. Do not show the warning on mobile. -->
    <div class="grow flex items-start justify-center h-full"
        *ngIf="(mode !== 'new' && mode !== 'edit') && !selectedCollectionControl.value && breakpoint.md.value">
        <div
            class="w-full max-w-[400px] p-10 flex flex-col items-center gap-3 border border-gray-300 rounded-[20px] mt-[100px]">
            <mat-icon svgIcon="files" class="w-[50px] h-[50px]"></mat-icon>
            <h2 class="text-3xl font-semibold" i18n>Kies collectie</h2>
            <p class="text-xl text-center" i18n>Selecteer een collectie in het menu om deze te bekijken of te bewerken
            </p>
        </div>
    </div>
</div>

<!-- Dialog to show when user leaves page with edited data -->
<dynamic-dialog #cancelDialog>
    <h1 title i18n>Collectie aanpassen annuleren</h1>
    <p i18n class="text-center">Weet je zeker dat je wilt stoppen met het aanpassen van deze collectie? De wijzigingen
        worden worden niet opgeslagen.</p>
</dynamic-dialog>